import { Injectable } from "@angular/core";
import { PractitionerSpecialty } from "src/app/ui/models/domains/pbm/practitioner-management/practitioner-specialty";
import { AbstractParser } from "../../parser";
import { parsePractitionerSpecialties } from "./practitioner-management-parse-function";

@Injectable()
export class PractitionerSpecialtiesParser extends AbstractParser<PractitionerSpecialty[]> {
  parse(payload: any): PractitionerSpecialty[] {
    return parsePractitionerSpecialties(payload);
  }
}
